import type { ShouldRevalidateFunction } from 'react-router';

import { sendSafeError } from '#src/lib/error.ts';

type GetVariablesFn = (params: any, url: URL) => Record<string, unknown>;

export const shouldRevalidateFn: (
  getVariables: GetVariablesFn | undefined
) => ShouldRevalidateFunction =
  getVariables =>
  ({ currentParams, nextParams, currentUrl, nextUrl }) => {
    if (!getVariables) {
      return false;
    }

    try {
      // Check if variables passed to query are different
      // This avoids loader being called for url parameter changes
      return (
        JSON.stringify(getVariables(currentParams, currentUrl)) !==
        JSON.stringify(getVariables(nextParams, nextUrl))
      );
    } catch (e) {
      sendSafeError(e);
      return true;
    }
  };
